export function useCustomMeta(path, name) {
  const route = useRoute()
  const config = useRuntimeConfig()
  const baseUrl = `${config.public.hostDomain}${config.app.baseURL}`
  const pageUrl = `${baseUrl}${route.path.replace(/^\//, '')}`
  const tdConfig = () => {
    if (path === 'top') {
      return {
        title: 'ライブカメラ',
        description: '【全国のライブカメラ】東京、新潟、愛知、大阪、沖縄など日本各地に設置された約2,500地点のお天気カメラで、リアルタイムな空の様子をチェック。道路・河川、雪や台風の状況、富士山やスキー場の様子を24時間前まで見られます。最新の気象情報は予報精度No.1ウェザーニュースで。',
        keyword: 'ライブカメラ,全国'
      }
    } else if (path === 'area') {
      return {
        title: `${name}のライブカメラ`,
        description: `【${name}のライブカメラ】${name}に設置されたお天気カメラでいまの空の様子を見ることができます。空港や道路・河川、雪や台風の状況、富士山やスキー場の様子を24時間前まで確認できます。最新の気象情報は予報精度No.1ウェザーニュースで。`,
        keyword: `ライブカメラ,${name}`
      }
    } else if (path === 'pref') {
      return {
        title: `${name}のライブカメラ`,
        description: `【${name}のライブカメラ】${name}内に設置されたお天気カメラでいまの空の様子を見ることができます。空港や道路・河川、雪や台風の状況、富士山やスキー場の様子を24時間前まで確認できます。最新の気象情報は予報精度No.1ウェザーニュースで。`,
        keyword: `ライブカメラ,${name}`
      }
    } else if (path === 'point') {
      return {
        title: `${name}のライブカメラ`,
        description: `【${name}のライブカメラ】${name}に設置されたお天気カメラでいまの空の様子をチェック。過去10分間・24時間のライブカメラを確認できます。雨雲レーダーや台風情報も併せてご活用ください。最新の気象情報は予報精度No.1ウェザーニュースで。`,
        keyword: `ライブカメラ,${name}`
      }
    } else {
      return {
        title: 'ライブカメラマップ',
        description: '【日本全国のライブカメラマップ】約2,500地点のライブカメラをマップ一覧で見られます。簡単に拡大・縮小ができ、雨や曇り、晴れなどの空の様子、雪や台風、雷の状況がわかります。最新の気象情報は予報精度No.1ウェザーニュースで。',
        keyword: 'ライブカメラ,マップ,地図'
      }
    }
  }
  useSeoMeta({
    ogImage: 'https://gvs.weathernews.jp/common/images/ogp/livecam@1x.png',
    ogType: 'website',
    ogSiteName: 'ウェザーニュース',
    viewport: 'width=device-width,initial-scale=1.0,minimum-scale=1.0,maximum-scale=3.0,user-scalable=yes',
    twitterCard: 'summary_large_image',
    twitterSite: '@wni_jp',
    twitterCreator: '@wni_jp',
    fbAppId: '1500388770270212',
    appleItunesApp: 'app-id=302955766',
    appleMobileWebAppCapable: 'yes',
    formatDetection: 'address=no'
  })
  useSeoMeta({
    title: `${tdConfig().title} - ウェザーニュース`,
    description: tdConfig().description,
    ogTitle: `${tdConfig().title} - ウェザーニュース`,
    ogDescription: tdConfig().description,
    ogUrl: pageUrl,
    appleMobileWebAppTitle: tdConfig().title,
    keywords: tdConfig().keyword
  })
  useHead({
    link: [
      { rel: 'canonical', href: pageUrl },
      { rel: 'preconnect', href: config.public.siteDataDomain, crossorigin: 'anonymous' },
      { rel: 'dns-prefetch', href: config.public.siteDataDomain },
      { rel: 'dns-prefetch', href: 'https://gvs.weathernews.jp/' },
      { rel: 'dns-prefetch', href: 'https://gis.weathernews.jp' }
    ]
  })
}
